<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-header">
          <h5>Notificari</h5>
        </div>
        <div class="card-body tab2-card">
          <div class="tab-pane fade active show" id="place" role="tabpanel" aria-labelledby="account-tab">
            <div class="category-table custom-datatable">
              <div class="table-responsive">
                <ng2-smart-table [settings]="notificationDisplaySettings" [source]="notifications?.content"
                                 (custom)="onCustomActionNotifications($event)"></ng2-smart-table>
              </div>
            </div>
            <div *ngIf="notifications?.totalElements > 0">
              <h4 class="pagination justify-content-center">
                Total notificari: {{notifications?.totalElements}}
              </h4>
              <ul class="pagination justify-content-center">
                <li class="page-item" (click)="previousPage()">
                  <a class="page-link" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </li>
                <li *ngFor="let page of paginationNotifications" [ngClass]="page.className" (click)="changePage(page)">
                  <a class="page-link">{{page.pageNumber + 1}}</a>
                </li>
                <li class="page-item" (click)="nextPage()">
                  <a class="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
